import { SET_ADMIN_CUSTOMERS } from '../actionTypes'
// import moment from 'moment'
// import _ from 'lodash'

const initialState = []

export default (state=initialState,  payload) => {
    switch(payload.type) {

    case SET_ADMIN_CUSTOMERS:
        return payload.adminCustomersData || null
    
    default:
        return state
    }
}